import React, { Component } from 'react';
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import GetDomains from './../projectmgmt/GetDomains';
import Loader from 'react-loader-spinner';
import { CheckBoxComponent } from '@syncfusion/ej2-react-buttons';

class NLPMlcd extends Component {
  constructor() {
    super(...arguments);
    this.dialogClose = () => {
      this.setState({ hideDialog: false, hideAddDialog: false, hideDeletePopup: false, hideMultipleDeletePopup: false,   hideDeleteAllPopup:false,
});
    };

    this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

    //for update dialog component ok click
    this.Okbutton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchMlcd()
        this.dialogClose();
      }
    }];

    //for add dialog component ok click
    this.addedButton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchMlcd()
        this.dialogClose();
        this.setState({ disabled: false })

      }
    }];

    //for delete dialog component yes or no click
    this.buttons = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true

      },
      'click': props => {
        this.deleteAjax(this.state.propsId)
      }
    }
      , {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({ hideDeletePopup: false });
      }
    }];

    //for delete dialog component ok click
    this.deleteSuccessbuttons = [{
      buttonModel: {
        content: 'Ok',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {

        this.dialogInstance.hide();
        this.fetchMlcd()
      }
    }];

    this.multipleDeleteButton = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {
        this.deleteMultipleRow()
      }
    }, {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideMultipleDeletePopup: false,
        });
      }
    }];

    //deleteall
    this.deleteAllButton = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {
        this.deleteAllAjax()
      }
    }, {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideDeleteAllPopup: false,
        });
      }
    }];
    this.state = {
      value: null,
      pageNum: null,
      showClearButton: false,
      showClearButtonOnclick: false,
      hideSubType: false,
      hideDeleteAllPopup:false,

      data: [{
        englishText: '',
        indicText: '',
        language: [],
        reviewed: false,
        namedEntity: [],
        subType: [],
        gender: []

      }],
      domain: [],
      fields: '',
      editedId: '-1',
      editImageSrc: './assets/images/edit.svg',
      contentEditable: "false",
      showStore: false,
      showPwd: false,
      viewedId: '-1',
      hideDialog: false,
      hideAddDialog: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      disabled: false,
      isChecked: true,
      query: null,
      domainId: null,
      namedEntityId: null,
      subTypeId: null,
      genderId: null,
      successResp: false,
      checkForEmpty: true,
      showBorder: true,
      toBeReviewed: true,
      selectedRows: [],
      checkBoxRows: [],
      disableMultipleDelete: true,
      hideMultipleDeletePopup: false
    };
    this.editImageSrc = "./assets/images/edit2.png";
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.currentSrc = "";
    this.newRowId = "0";
    this.language = "";
    this.namedEntity = "";
    this.domain = "";
    this.toBeReviewed = false;
    this.searchDataMap = [];
    this.change = false;

  }




  componentDidMount() {
    setTimeout(() => {
      this.fetchLanguageAjax();
      this.fetchDomainAjax();
      this.fetchNamedEntityAjax();
      this.fetchSubTypeAjax();
      this.fetchGenderAjax();
      this.getCustomEntityType();
    }, 300);

    this.language = document.getElementById('languageIdDropDown').value;
    this.namedEntity = document.getElementById('namedEntityInDropDown').value;
    this.domain = document.getElementById('domainDropDown').value;
    this.toBeReviewed = true;
    var mlcdDataLoaderTimerController = this;
    var mlcdDataLoaderTimer = setInterval(function () {

      if (((this.language != "") || (this.language != null)) &&
        ((this.namedEntity != "") || (this.namedEntity != null)) &&
        ((this.domain != "") || (this.domainId != null))) {


        clearTimeout(mlcdDataLoaderTimer);
        mlcdDataLoaderTimerController.initialLoaddataMlcd();


      }
    }, 3000);
    var initialController = this;
    document.addEventListener("projectChanged", function (event) {
      if (document.getElementById('languageIdDropDown') != null &&
        document.getElementById('namedEntityInDropDown') != null &&
        document.getElementById('domainDropDown') != null) {
        initialController.fetchLanguageAjax();
        initialController.fetchDomainAjax();
        initialController.fetchNamedEntityAjax();
        initialController.fetchSubTypeAjax();
        initialController.fetchGenderAjax();
        initialController.getCustomEntityType();

        initialController.language = document.getElementById('languageIdDropDown').value;
        initialController.namedEntity = document.getElementById('namedEntityInDropDown').value;
        initialController.domain = document.getElementById('domainDropDown').value;
        initialController.toBeReviewed = document.getElementById('toBeReviewed').checked;
        var mlcdDataLoaderTimerController = this;
        var mlcdDataLoaderTimer = setInterval(function () {

          if (((initialController.language != "") || (initialController.language != null)) &&
            ((initialController.namedEntity != "") || (initialController.namedEntity != null)) &&
            ((initialController.domain != "") || (initialController.domainId != null))) {


            clearTimeout(mlcdDataLoaderTimer);
            initialController.initialLoaddataMlcd();


          }
        }, 3000);
      }
    });

  }
  //---------------Delete all------------------------//
    deleteAllAjax = () => {
      let deleteApiViewController = this;
      $.ajax({
        url: "/api/multi-lingual-client-data-delete-all" ,
        async: false,
        method: 'POST',
        headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
        data:{
           language: document.getElementById('languageIdDropDown').value,
           projectId: localStorage.getItem('currentProjectId'),
             },
        success: function (res) {

          if (res.success === true) {
            deleteApiViewController.state.hideDeleteAllPopup = false;
            deleteApiViewController.state.disableMultipleDelete = true;
            deleteApiViewController.state.checkBoxRows = [];
            deleteApiViewController.setState(deleteApiViewController.state);
            deleteApiViewController.fetchMlcd();
            deleteApiViewController.notifyDeleteAllSuccess();
          } else {
            deleteApiViewController.NotifyFailedDelete(res.result);
          }
        },

        error: function (xhr, status, error) {
          var errorMessage = xhr.status + ': ' + xhr.statusText
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }

      });
    }
  notifyDeleteAllSuccess() {
    toast.dismiss();
    toast(<b>
      <img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
        content="" />&nbsp;&nbsp;All MLCDs have been deleted Successfully</b>, {
      position: "top-center",
    });

  }

  saveAjax(props, e) {

    var addApiController = this;

    props.original.englishText = document.getElementById("englishText" + props.index).innerText;
    props.original.indicText = document.getElementById("indicText" + props.index).innerText;


    props.original.language = document.getElementById('languageIdDropDown').value;
    props.original.namedEntity = document.getElementById('namedEntityInDropDown').value;
    props.original.subType = this.state.subTypeId;
    props.original.gender = this.state.genderId;
    props.original.domain = document.getElementById('domainDropDown').value;
    props.original.reviewed = document.getElementById('reviewed' + props.index).checked;
    props.original.customType = document.getElementById('customEntityType').value;
    this.state.editedId = "-1";
    this.setState(this.state);


    var validateResult = this.validateCells(props.original.englishText,
      props.original.indicText, props.original.subType, props.original.gender,
      document.getElementById('reviewed' + props.index).checked,props.original.customType);
   var customType = props.original.customType
           if(customType == "None"){
               customType = "";
           }
    if (validateResult == true) {
      var updatedData = {

        indicText: props.original.indicText,
        englishText: props.original.englishText,
        language: props.original.language,
        namedEntity: props.original.namedEntity,
        neSubType: props.original.subType,
        gender: props.original.gender,
        domainId: props.original.domain,
        reviewed: document.getElementById('reviewed' + props.index).checked,
        nonNamedEntity: 'true',
        projectId: localStorage.getItem('currentProjectId'),
        customType: customType
      };



      $.ajax({
        url: "/api/multi-lingual-client-data",
        async: false,
        method: 'POST',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },

        data: JSON.stringify(updatedData),

        processData: false,

        contentType: "application/json; charset=UTF-8",

        success: function (res) {

          if (res.success === true) {

            addApiController.NotifyAdd();
            addApiController.fetchMlcd();
            addApiController.state.disabled = false;


          } else {
            addApiController.NotifyFailedAdd(res.result);
          }
        },
        error: function (xhr, status, error) {
          var errorMessage = xhr.status + ': ' + xhr.statusText
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      })
    }

  }
  NotifyAdd() {
    toast.dismiss();
    toast(<b>
      <img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;MLCD Added Successfully</b>, {
      position: "top-center",

    });

  }
  NotifyFailedAdd(response) {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />{response}</b>, {
      position: "top-center"
    });
    this.fetchMlcd();
  }

     updateAjax(props, e) {

    this.state.editedId = "-1";
    props.original.englishText = document.getElementById("englishText" + props.index).innerText;
    props.original.indicText = document.getElementById("indicText" + props.index).innerText;
    props.original.customType = document.getElementById('customEntityType').value;
    var customType = props.original.customType;
     if(customType == "None"){
         customType = "";
     }
     var updatedData = {

      id: props.original.id,
      englishText: props.original.englishText,
      indicText: props.original.indicText,
      language: document.getElementById('languageIdDropDown').value,
      neSubType: this.state.subTypeId,
      namedEntity: document.getElementById('namedEntityInDropDown').value,
      gender: this.state.genderId,
      domainId: document.getElementById('domainDropDown').value,
      reviewed: document.getElementById('reviewed' + props.index).checked,
      projectId: localStorage.getItem('currentProjectId'),
      customType: customType


    };
    var validateResult = this.updateDataMissing(
      props.original.englishText,

      document.getElementById('languageIdDropDown').value,
      document.getElementById('namedEntityInDropDown').value,
      document.getElementById('domainDropDown').value,
      this.state.subTypeId,
      this.state.genderId,
      props.original.indicText,
      document.getElementById('reviewed' + props.index).checked);
    var upadteMlcdController = this

    if (validateResult == true) {

      $.ajax({

        url: "/api/multi-lingual-client-data",

        async: false,

        method: 'PATCH',

        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },

        data: JSON.stringify(updatedData),

        processData: false,

        contentType: "application/json; charset=UTF-8",

        success: function (res) {
          if (res.success === true) {
            upadteMlcdController.NotifyUpdate();
            upadteMlcdController.fetchMlcd();

          } else {
            upadteMlcdController.NotifyFailedUpdate(res.result);
          }
        },
        error: function (xhr, status, error) {
          var errorMessage = xhr.status + ': ' + xhr.statusText
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }

      })
    }
  }

  getCustomEntityType = () => {
    let mlcdController = this;
    $.ajax({
      url: "/api/custom-entity-type",
      async: false,
      method: 'GET',
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      data: { projectId: localStorage.getItem('currentProjectId') },
      success: function (res) {
        if (res.success === true) {
          var responseData = res.result;
          var numberOfSubtypes = responseData.length;
          var ele3 = document.getElementById("customEntityType");
         if (ele3 != "") {
               if (ele3 != null) {
                 if (ele3.value != "Select Custom entity type") {
                   ele3.innerHTML = "";
                 }
                  ele3.innerHTML= ele3.innerHTML + '<option value="">' + "None" + '</option>';
                 for (var i = 0; i < numberOfSubtypes; i++) {
                   ele3.innerHTML = ele3.innerHTML + '<option value="' + responseData[i]['typeName'] +
                     '">' + responseData[i]['typeName'] + '</option>';
                 }
               }
             }
        } else {
          mlcdController.NotifyError(res.result);
        }
      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ': ' + xhr.statusText
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }
    });
  }


  NotifyUpdate() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;MLCD Updated Successfully</b>, {
      position: "top-center",

    });
  }
  NotifyFailedUpdate(response) {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      {response}</b>, {
      position: "top-center"
    });
    this.fetchMlcd();
  }

  deleteAjax = (id) => {
    let deleteRowViewController = this.state.data;
    var deleteConstructorVariables = this;
    let deleteApiViewController = this;

    $.ajax({

      url: "/api/multi-lingual-client-data/" + id,

      async: false,

      method: 'DELETE',

      headers: {
        "Authorization": "Bearer " +
          localStorage.getItem("access_token")
      },

      success: function (res) {

        if (res.success === true) {

          deleteApiViewController.setState({ deleteRow: true });
          deleteConstructorVariables.setState({ hideDeletePopup: false });
          deleteRowViewController.splice(id, 1);
          deleteApiViewController.NotifyDelete();
          deleteApiViewController.fetchMlcd();


        } else {

          deleteApiViewController.NotifyFailedDelete(res.result);

        }
      },

      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ': ' + xhr.statusText
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }

    });

  }

  deleteMultipleRow = () => {
    let deleteApiViewController = this;
    var idListVal = deleteApiViewController.state.selectedRows;
    var idList = [];
    for (var i = 0; i < idListVal.length; i++) {
      idList.push(idListVal[i].id);
    }

    $.ajax({
      url: "/api/mlcd-delete-multiple/" + idList,
      async: false,
      method: 'DELETE',
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },

      success: function (res) {

        if (res.success === true) {
          deleteApiViewController.state.hideMultipleDeletePopup = false;
          deleteApiViewController.state.disableMultipleDelete = true;
          deleteApiViewController.state.checkBoxRows = [];
          deleteApiViewController.setState(deleteApiViewController.state);
          deleteApiViewController.initialLoaddataMlcd();
          deleteApiViewController.notifyMultipleDeleteSuccess();
        } else {
          deleteApiViewController.NotifyFailedDelete(res.result);
        }
      },

      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ': ' + xhr.statusText
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }

    });
  }

  notifyMultipleDeleteSuccess() {
    toast.dismiss();
    toast(<b>
      <img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
        content="" />&nbsp;&nbsp;Selected Multi Lingual Entities Deleted Successfully</b>, {
      position: "top-center",
    });

  }

  NotifyDelete() {
    toast.dismiss();
    toast(<b>
      <img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
        content="" />&nbsp;&nbsp;MLCD Deleted Successfully</b>, {
      position: "top-center",
    });

  }


  NotifyFailedDelete(response) {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      {response}</b>, {
      position: "top-center"
    });
    this.fetchMlcd();
  }



  initialLoaddataMlcd = () => {
    var fetchApiController = this;
    var validateResult = this.dataMissing(this.language,
      this.namedEntity,
      this.domain)

    if (validateResult == true) {

      $.ajax({
        url: "/api/multi-lingual-client-data/search",

        async: false,

        method: 'GET',

        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token")
        },

        data: {
          language: this.language,
          namedEntity: this.namedEntity,
          domainId: this.domain,
          toBeReviewed: this.toBeReviewed,
          projectId: localStorage.getItem('currentProjectId'),

        },

        success: function (res) {
          if (res.success === true) {
            fetchApiController.setState({
              data: res.result,
              successResp: true
            });
          }
          else {
            fetchApiController.NotifyFailedLoad(res.result);
            fetchApiController.setState({

              successResp: false
            });
          }
        },
        error: function (xhr, status, error) {
          var errorMessage = xhr.status + ': ' + xhr.statusText
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      })
    } else {
      fetchApiController.setState({

        successResp: true,
        checkForEmpty: false
      });
    }
  }

  NotifyFailedLoad(response) {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      {response}</b>, {
      position: "top-center"
    });
    this.fetchMlcd();
  }



  fetchMlcd = () => {
    var fetchApiController = this;

    var updatedData = fetchApiController.validateFetchData();
    console.log(updatedData);
    var validateResult = fetchApiController.dataMissing(
      document.getElementById('languageIdDropDown').value,
      document.getElementById('namedEntityInDropDown').value,
      document.getElementById('domainDropDown').value)
    if (validateResult == true) {

      $.ajax({
        url: "/api/multi-lingual-client-data/search",

        async: false,

        method: 'GET',

        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token")
        },

        data: fetchApiController.searchDataMap[0],

        success: function (res) {
          if (res.success === true) {
          fetchApiController.state.data = res.result;
          fetchApiController.state.disabled = false;
          fetchApiController.setState(fetchApiController.state);
//            fetchApiController.setState({
//              data: res.result,
//              disabled: false
//
//            });

          }
          else {

            fetchApiController.NotifyFailedLoad(res.result);
          }
        },

        error: function (xhr, status, error) {
          var errorMessage = xhr.status + ': ' + xhr.statusText
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }

      })
    }


  }

  NotifyFailedLoad(response) {
    toast.dismiss();
    toast(<b>
      <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
        content="" />
      {response}</b>, {
      position: "top-center"
    });
    this.fetchMlcd();
  }


  querySearchAjax = () => {
    var fetchApiController = this;

    var updatedData = fetchApiController.validateFetchData();
    $.ajax({
      url: "/api/multi-lingual-client-data-search",

      async: false,

      method: 'GET',

      headers: {
        'Authorization': "Bearer " + localStorage.getItem("access_token")
      },

      data: {
        language: document.getElementById('languageIdDropDown').value,
        projectId: localStorage.getItem('currentProjectId'),
        query: document.getElementById('query').value
      },

      success: function (res) {
        if (res.success === true) {
          fetchApiController.setState({
            data: res.result,
            disabled: false

          });

        }
        else {

          fetchApiController.NotifyFailedLoad(res.result);
        }
      },

      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ': ' + xhr.statusText
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }

    })



  }
  validateFetchData() {

    var queryData = document.getElementById('query').value;
    var gender = document.getElementById('gender').value;
    var subType = document.getElementById('subType').value;
    this.searchDataMap = [];
    var customType = document.getElementById('customEntityType').value;

    if(customType != "" &&
    document.getElementById('namedEntityInDropDown').value == "CUSTOM" &&
                           (gender!="Select Gender")
                           && queryData ==""){
       this.searchDataMap.push({
              language: document.getElementById('languageIdDropDown').value,
              namedEntity: document.getElementById('namedEntityInDropDown').value,
              domainId: document.getElementById('domainDropDown').value,
              toBeReviewed: document.getElementById('toBeReviewed').checked,
              projectId: localStorage.getItem('currentProjectId'),
              customType: customType,
              gender: document.getElementById('gender').value

            });
           return this.searchDataMap;
     }
    if(document.getElementById('namedEntityInDropDown').value == "CUSTOM" &&
    (gender!="Select Gender")
    && queryData ==""){
     this.searchDataMap.push({
        language: document.getElementById('languageIdDropDown').value,
        namedEntity: document.getElementById('namedEntityInDropDown').value,
        domainId: document.getElementById('domainDropDown').value,
        toBeReviewed: document.getElementById('toBeReviewed').checked,
        projectId: localStorage.getItem('currentProjectId'),
     //   customType: customType,
        gender: document.getElementById('gender').value

      });
     return this.searchDataMap;

    }if(document.getElementById('namedEntityInDropDown').value == "CUSTOM" &&
         ( gender!="Select Gender") && queryData !=""){
          this.searchDataMap.push({
             language: document.getElementById('languageIdDropDown').value,
             namedEntity: document.getElementById('namedEntityInDropDown').value,
             domainId: document.getElementById('domainDropDown').value,
             toBeReviewed: document.getElementById('toBeReviewed').checked,
             projectId: localStorage.getItem('currentProjectId'),
             customType: customType,
             gender: document.getElementById('gender').value,
             query: document.getElementById('query').value
       });
       return this.searchDataMap;

     }



      if ((queryData == "") &&
      (gender == "Select Gender") &&
      (subType == "Select Sub-Type")) {
      this.searchDataMap.push({
        language: document.getElementById('languageIdDropDown').value,
        namedEntity: document.getElementById('namedEntityInDropDown').value,
        domainId: document.getElementById('domainDropDown').value,
        toBeReviewed: document.getElementById('toBeReviewed').checked,
        projectId: localStorage.getItem('currentProjectId'),

      })
     return this.searchDataMap;

    } else if ((queryData != "") &&
      ( gender == "Select Gender") &&
      (subType == "" && subType == "Select Sub-Type")) {
      this.searchDataMap.push({
        language: document.getElementById('languageIdDropDown').value,
        namedEntity: document.getElementById('namedEntityInDropDown').value,
        domainId: document.getElementById('domainDropDown').value,
        toBeReviewed: document.getElementById('toBeReviewed').checked,
        projectId: localStorage.getItem('currentProjectId'),
        query: document.getElementById('query').value

      });
     return this.searchDataMap;

    }






    else if ((queryData != "") &&
      ( gender == "Select Gender") &&
      (subType != "" && subType != "Select Sub-Type")) {
      this.searchDataMap.push({
        language: document.getElementById('languageIdDropDown').value,
        namedEntity: document.getElementById('namedEntityInDropDown').value,
        domainId: document.getElementById('domainDropDown').value,
        toBeReviewed: document.getElementById('toBeReviewed').checked,
        projectId: localStorage.getItem('currentProjectId'),
        neSubType: document.getElementById('subType').value,
        query: document.getElementById('query').value
      });
     return this.searchDataMap;

    }else if ((gender == "Select Gender") &&
            (subType != "Select Sub-Type") &&
            (queryData == "" ) &&
           document.getElementById('namedEntityInDropDown').value != "CUSTOM") {

           this.searchDataMap.push({
             language: document.getElementById('languageIdDropDown').value,
             namedEntity: document.getElementById('namedEntityInDropDown').value,
             domainId: document.getElementById('domainDropDown').value,
             toBeReviewed: document.getElementById('toBeReviewed').checked,
             projectId: localStorage.getItem('currentProjectId'),
             neSubType: document.getElementById('subType').value

           })
          return this.searchDataMap;

         }





     else if ((queryData != "") &&
      (gender != "Select Gender") &&
      (subType != "Select Sub-Type")) {
      this.searchDataMap.push({
        language: document.getElementById('languageIdDropDown').value,
        namedEntity: document.getElementById('namedEntityInDropDown').value,
        domainId: document.getElementById('domainDropDown').value,
        toBeReviewed: document.getElementById('toBeReviewed').checked,
        projectId: localStorage.getItem('currentProjectId'),
        gender: document.getElementById('gender').value,
        neSubType: document.getElementById('subType').value,
        query: document.getElementById('query').value
      });
     return this.searchDataMap;

    } else if ((queryData == "") &&
            (gender != "Select Gender") &&
            (subType != "Select Sub-Type" )) {
            this.searchDataMap.push({
              language: document.getElementById('languageIdDropDown').value,
              namedEntity: document.getElementById('namedEntityInDropDown').value,
              domainId: document.getElementById('domainDropDown').value,
              toBeReviewed: document.getElementById('toBeReviewed').checked,
              projectId: localStorage.getItem('currentProjectId'),
              gender: document.getElementById('gender').value,
              neSubType: document.getElementById('subType').value,

            });
           return this.searchDataMap;

          }


         else if (( gender != "Select Gender") &&
           (subType == "Select Sub-Type") &&
           (queryData == "") &&
            document.getElementById('namedEntityInDropDown').value != "CUSTOM") {

           this.searchDataMap.push({
             language: document.getElementById('languageIdDropDown').value,
             namedEntity: document.getElementById('namedEntityInDropDown').value,
             domainId: document.getElementById('domainDropDown').value,
             toBeReviewed: document.getElementById('toBeReviewed').checked,
             projectId: localStorage.getItem('currentProjectId'),
             gender: document.getElementById('gender').value
           });

          return this.searchDataMap;

         }
         else if ((gender != "Select Gender") &&
           (subType == "Select Sub-Type") &&
           (queryData != "")&&
           document.getElementById('namedEntityInDropDown').value != "CUSTOM" ) {

           this.searchDataMap.push({
             language: document.getElementById('languageIdDropDown').value,
             namedEntity: document.getElementById('namedEntityInDropDown').value,
             domainId: document.getElementById('domainDropDown').value,
             toBeReviewed: document.getElementById('toBeReviewed').checked,
             projectId: localStorage.getItem('currentProjectId'),
             gender: document.getElementById('gender').value,
             query: document.getElementById('query').value
           });

          return this.searchDataMap;

         }






      else {
      this.searchDataMap.push({
        language: document.getElementById('languageIdDropDown').value,
        namedEntity: document.getElementById('namedEntityInDropDown').value,
        domainId: document.getElementById('domainDropDown').value,
        toBeReviewed: document.getElementById('toBeReviewed').checked,
        projectId: localStorage.getItem('currentProjectId'),


      });
      return this.searchDataMap;

    }
  }

  fetchDomainAjax = () => {
    var domain = GetDomains();
    this.setState({ domain: domain });
    var domainOptionTag = document.getElementById("domainDropDown");
    if (domainOptionTag != "") {
      if (domainOptionTag != null) {
        domainOptionTag.innerHTML = "";



        for (var i = 0; i < domain.length; i++) {
          domainOptionTag.innerHTML = domainOptionTag.innerHTML + '<option value="' +
            domain[i]["domainId"] + '">' + domain[i]["domain"] + '</option>';
        }
        this.setState({ domainId: document.getElementById('domainDropDown') })
        this.setState(this.state);
      }
    }

  }



  fetchLanguageAjax() {
      var languageController = this;
      var languageVar = this;
      $.ajax({
          url: "/api/agent-languages-nlp",
          async: false,
          method: 'GET',
          data: { projectId: localStorage.getItem('currentProjectId') },
          headers: {
              'Authorization': "Bearer " + localStorage.getItem("access_token"),
              'Content-Type': 'application/json'
          },
          success: function (res) {
              if (res.success === true) {
                var loadedLang = res.result;

                languageController.setState({ language: loadedLang });
                var numberOfLanguages = loadedLang.length;
                var ele3 = document.getElementById("languageIdDropDown");
    
                if (ele3 != "") {
                  if (ele3 != null) {
                    ele3.innerHTML = "";
    
    
                    for (var i = 0; i < numberOfLanguages; i++) {
                      ele3.innerHTML = ele3.innerHTML + '<option value="' + loadedLang[i]
                      ['code'] + '">' + loadedLang[i]['name'] + '</option>';
                    }
                  }
                }
              } else {
                  languageController.NotifyFailToLoadLanguages(res.result);
              }
          },
          error: function (xhr, status, error) {
              var errorMessage = xhr.status + ': ' + xhr.statusText
              if (xhr.status == 401) {
                  window.location.href = "/platform/";
              }
          }
      });
  }
   


  fetchNamedEntityAjax() {
    var domainController = this;
    var responseData = []
    $.ajax(
      {
        url: "/api/named-entities",
        async: false,
        method: 'GET',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token")

        },
        success: function (res) {
          if (res.success === true) {
            responseData = res.result;

            domainController.setState({ namedEntity: responseData });
            var numberOfnamedEntity = responseData.length;
            var ele3 = document.getElementById("namedEntityInDropDown");
            if (ele3 != "") {
              if (ele3 != null) {
                ele3.innerHTML = "";

                for (var i = 0; i < numberOfnamedEntity; i++) {
                  ele3.innerHTML = ele3.innerHTML + '<option value="' +
                    responseData[i]['code'] +
                    '">' + responseData[i]['name'] + '</option>';
                }
              }
            }
          } else {
            domainController.NotifyFailedLoad(res.result);
          }
        },
        error: function (xhr, status, error) {
          var errorMessage = xhr.status + ': ' + xhr.statusText
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }

      }
    )
    if (document.getElementById('namedEntityInDropDown') != null) {
      let valueOfNamedEntityId = document.getElementById('namedEntityInDropDown').value;

      this.setState({ namedEntityId: valueOfNamedEntityId })
    }


  }


  fetchSubTypeAjax() {
    var fetchController = this;
    var responseData = []
    $.ajax(
      {
        url: "/api/ne-sub-types",
        async: false,
        method: 'GET',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token")
        },
        success: function (res) {
          if (res.success === true) {
            responseData = res.result;
            var numberOfSubtypes = responseData.length;
            var ele3 = document.getElementById("subType");
            if (ele3 != "") {
              if (ele3 != null) {
                if (ele3.value != "Select Sub-Type") {
                  ele3.innerHTML = "";
                }

                  for (var i = 0; i < numberOfSubtypes; i++) {

                    ele3.innerHTML = ele3.innerHTML + '<option value="' + responseData[i]['code'] +
                      '">' + responseData[i]['name'] + '</option>';
                  }
                }
              }
          }

          else {
            fetchController.NotifyFailedLoad(res.result);
          }
        }, error: function (xhr, status, error) {
          var errorMessage = xhr.status + ': ' + xhr.statusText
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      }
    )

  }
  subTypehandleChange = () => {
    let valueOfSubTypeId = document.getElementById('subType').value;
    this.state.subTypeId = valueOfSubTypeId;
    this.fetchMlcd();
//  this.setState({ subTypeId: valueOfSubTypeId })
  }

  customTypehandleChange = () => {
  //let valueOfCustomEntityId = document.getElementById('customEntityType').value;

  //this.setState({ customEntityTypeId: valueOfCustomEntityId })
    this.fetchMlcd();
  }



  fetchGenderAjax() {
    var fetchController = this;
    var responseData = []
    $.ajax(
      {
        url: "/api/genders",
        async: false,
        method: 'GET',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token")
        },
        success: function (res) {
          if (res.success === true) {
            responseData = res.result;
            var numberOfGenders = responseData.length;
            var ele3 = document.getElementById("gender");
            if (ele3 != "") {
              if (ele3 != null) {
                if (ele3.value != "Select Gender") {
                  ele3.innerHTML = "";
                }

                  for (var i = 0; i < numberOfGenders; i++) {
                    ele3.innerHTML = ele3.innerHTML + '<option value="' + responseData[i]['code'] +
                      '">' + responseData[i]['name'] + '</option>';
                  }
                }
              }

          } else {
            fetchController.NotifyFailedLoad(res.result);
          }
        },
        error: function (xhr, status, error) {
          var errorMessage = xhr.status + ': ' + xhr.statusText
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      }
    )

  }


  genderhandleChange = () => {
    let valueOfGenderId = document.getElementById('gender').value;
    this.state.genderId = valueOfGenderId;
  //this.setState({ genderId: valueOfGenderId })
    this.fetchMlcd();
  }

  NotifyEmptyFieldsIndic() {
   toast.dismiss();
      toast(<b><img src="assets/images/warn.svg"
        style={{ paddingRight: '0px', height: '20px', width: '20px' }}
        content="" />&nbsp;&nbsp;Please fill indic data</b>, {
        position: "top-center"
      });
  }
  NotifyEmptyFields() {

  if((document.getElementById("gender").value == "Select Gender"
   || document.getElementById("gender").value == null)
   && this.state.hideSubType == true){
    toast(<b><img src="assets/images/warn.svg"
          style={{ paddingRight: '0px', height: '20px', width: '20px' }}
          content="" />&nbsp;&nbsp;A genders is needed to add a MLCD </b>, {
          position: "top-center"
        });

             return false;
       }
    if (document.getElementById("languageIdDropDown").value == "" || document.getElementById("languageIdDropDown").value == null) {

      toast(<b><img src="assets/images/warn.svg"
        style={{ paddingRight: '0px', height: '20px', width: '20px' }}
        content="" />&nbsp;&nbsp;A indic language is needed to add a MLCD</b>, {
        position: "top-center"
      });
    }
    else if ((document.getElementById("subType").value == "Select Sub-Type" || document.getElementById("subType").value == null) &&
      (document.getElementById("gender").value == "Select Gender" || document.getElementById("gender").value == null)) {
      toast(<b><img src="assets/images/warn.svg"
        style={{ paddingRight: '0px', height: '20px', width: '20px' }}
        content="" />&nbsp;&nbsp;Select the Sub-Type and gender for your MLCD</b>, {
        position: "top-center"
      });
    }
    else if (document.getElementById("subType").value == "Select Sub-Type" || document.getElementById("subType").value == null) {
      toast(<b><img src="assets/images/warn.svg"
        style={{ paddingRight: '0px', height: '20px', width: '20px' }}
        content="" />&nbsp;&nbsp;Select the Sub-Type for your MLCD</b>, {
        position: "top-center"
      });
    } else if (document.getElementById("gender").value == "Select Gender" || document.getElementById("gender").value == null) {
      toast(<b><img src="assets/images/warn.svg"
        style={{ paddingRight: '0px', height: '20px', width: '20px' }}
        content="" />&nbsp;&nbsp;Select the Gender for your MLCD</b>, {
        position: "top-center"
      });
    }

//    else {
//      toast.dismiss();
//      toast(<b><img src="assets/images/warn.svg"
//        style={{ paddingRight: '0px', height: '20px', width: '20px' }}
//        content="" />&nbsp;&nbsp;Please fill all the data</b>, {
//        position: "top-center"
//      });
//    }
  }

  addRow = (data) => {
    var rowController = this;
    if (rowController.state.pageNum != 0) {
      rowController.setState({ pageNum: 0 })
    }

    this.state.data.unshift({
      englishText: '',
      indicText: '',
      reviewed: '',
      language: '',
      domain: '',
      namedEntity: '',
      subType: '',
      gender: ''

    });
    this.setState({
      data: this.state.data,

      disabled: true
    })
  }

  editCell(props, e) {
    this.currentSrc = this.src;
    this.markAsBeingEdited(props.original.id);
  }

  markAsBeingEdited(id) {

    this.state.editedId = id;
    var stateObj = this.state;
    this.setState(stateObj);
  }



  dataMissing(language, namedEntity, domain) {
    if (language == "" || language == null) {
      this.NotifyLanguageDataMissing();
      return false;
    }
    else if (domain == "" || domain == null) {

      this.NotifyDomainDataMissing();
      return false;
    }
    else if (namedEntity == "" || namedEntity == null) {

      this.NotifyNamedEntityDataMissing();
      return false;
    }
    else {

      return true;
    }
  }

  NotifyLanguageDataMissing() {
    toast.dismiss();
    this.setState({

      disabled: true

    })
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;Oops!you have not selected Indic language for your project</b>, {
      position: "top-center"
    });
  }
  NotifyDomainDataMissing() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;Please Select Domain</b>, {
      position: "top-center"
    });
  }
  NotifyNamedEntityDataMissing() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;Please Select named entity</b>, {
      position: "top-center"
    });
  }


  validateCells(englishText, indicText, subtype, gender, reviewed,customType) {

    if (englishText == "" || gender == "Select Gender"
      || subtype == null || gender == null) {
      this.NotifyEmptyFields();
      return false;
    }
    if (reviewed === true && indicText == "") {
      this.NotifyEmptyFieldsIndic();
      return false;
    }
    else {
      return true;
    }
  }

  updateDataMissing(englishText, language, namedEntity,
    domain, subType, gender, indicText, reviewed) {
    if (englishText == "" || subType == "Select Sub-Type" || gender == "Select Gender"
      || subType == null || gender == null || language == "" || namedEntity == "" || domain == "") {
      this.NotifyEmptyFields();
      return false;
    }
    if (reviewed === true && indicText == "") {
      this.NotifyEmptyFieldsIndic();
      return false;
    }
    else {
      return true;
    }
  }




  refreshData = (id) => {
    var refreshContent = this
    refreshContent = this.state.editedId = id;
    this.state.selectedRows = [];
    this.state.disableMultipleDelete = true;
    this.state.checkBoxRows = [];
    this.fetchMlcd();
    this.state.disabled = false;
   // this.state.showTable= true
    this.setState(this.state);
  }
  onenglishTexthandleChange(event, props) {

    this.state.data[props.index].englishText = document.getElementById("englishText" + props.index).innerText;
    this.setState(
      this.state);

  }
  onIndicTexthandleChange(event, props) {

    this.state.data[props.index].indicText = document.getElementById("indicText" + props.index).innerText;
    this.setState(
      this.state);

  }

  handleChecked = () => {

    this.fetchMlcd();

  }

  domainhandleChange = (e) => {

    this.fetchMlcd();

  }
  langhandleChange = (e) => {
    this.fetchMlcd();
  }


  NotifyCustomTypeMissing() {
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;Oops!you have not selected Custom type for your project</b>, {
      position: "top-center"
    });
  }

  namedEntityhandleChange = (e) => {
    if (document.getElementById('namedEntityInDropDown').value === 'CUSTOM') {
      this.state.hideSubType = true;
      this.state.subTypeId = 'UNKNOWN';
//      if (document.getElementById("customEntityType").value === "") {
//        this.NotifyCustomTypeMissing();
//      }
    } else {
      this.state.hideSubType = false;
    }
    this.setState(this.state)
    this.fetchMlcd();
  }
  queryHandleChange = (e) => {
    this.fetchMlcd();
  }
  handleChangeReview = (e) => {
    this.change = true
  }
  onKeyPressHandleChange = (event) => {
    if (event.key === "Enter") {
      this.fetchMlcd();
    }
  }
  englishTextHandleChange(event, props) {

    props.original.englishTextHandleChange = event.target.value;

    this.setState(this.state);
  }
  indicTextHandleChange(event, props) {

    props.original.indicTextHandleChange = event.target.value;

    this.setState(this.state);
  }

  onPageChange = (e) => {
    this.setState({ pageNum: e })
  }
  reset = () => {

    if (document.getElementById('query').innerText == '') {
      this.setState({ showClearButton: false })
    }


    var resetButton = document.getElementById("query");

    if (resetButton) {
      resetButton.value = "";

    }

  }
  contentChange = (e) => {
    this.setState({ showClearButton: true })
  }

  selectedRow = (props, e) => {
    this.state.selectedRows = [];
    var jsonData = props.original;
    for (var i = 0; i < this.state.checkBoxRows.length; i++) {
      if (this.state.checkBoxRows[i]["id"] == jsonData.id) {
        this.state.checkBoxRows.splice(i, 1);
      }
    }
    if (e.target.checked) {
      jsonData["selected"] = true;
    } else {
      jsonData["selected"] = false;
    }
    this.state.checkBoxRows.push(jsonData);
    for (var i = 0; i < this.state.checkBoxRows.length; i++) {
      if (this.state.checkBoxRows[i]["selected"] == true) {
        this.state.selectedRows.push(this.state.checkBoxRows[i]);
      }
    }
    if (this.state.selectedRows.length > 0) {
      this.state.disableMultipleDelete = false;
    } else {
      this.state.disableMultipleDelete = true;
    }
    this.setState(this.state);
  }

  render() {
    const { data } = this.state

    return (
      <div>
        <Loader
          type="TailSpin"
          color="#282a65"
          visible={this.state.successResp ? false : true}
          height={300}
          width={50}
          timeout={3000}
          style={{ textAlign: 'center' }}
        />
        <div style={{ display: this.state.successResp ? 'block' : 'none' }}>
          {/* for reactTable */}
          <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
          <link rel="stylesheet" href="assets/css/toggleButton.css" />


          {/* for toaster */}
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />

          {/* for dialog component */}
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          <meta charSet="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta httpEquiv="x-ua-compatible" content="ie=edge" />


          {/* for checkbox component */}

          <link rel="stylesheet" href="assets/css/Checkbox/Checkboxbutton.css" />
          <link rel="stylesheet" href="assets/css/Checkbox/CheckboxTick.css" />






          <div style={{ backgroundColor: '#F9F9FB', marginTop: '-15px' }}>
            <div className="row">
              <div className="col-sm-4">

              </div></div>

            <div className="row">




              {/* language */}
              <div className="col-sm-4">
                <h6 className="taglineTxt"></h6>
                <label style={{ marginLeft: '20px' }}>Language</label>
                <select className="input-group mb-3 form-control select2 "
                  value={this.state.value}
                  id="languageIdDropDown" className="languageIdDropDown"
                  onChange={this.langhandleChange}
                  style={{
                    width: '50%', height: '30px', borderRadius: '4px',
                    backgroundColor: '#F9F9FB',
                    marginLeft: '16px'

                  }} >

                </select>
              </div>





              {/* domain */}
              <div className="col-sm-4">
                <h6 className="taglineTxt"></h6>
                <label>Domain</label>
                <select className="input-group mb-3 form-control select2 "
                  value={this.state.value}
                  id="domainDropDown" className="domainDropDown"
                  onChange={this.domainhandleChange}
                  style={{
                    height: '30px', borderRadius: '4px', width: '50%',
                    backgroundColor: '#F9F9FB', marginLeft: '18px'
                  }}>

                </select>
              </div>








              {/* named entity */}
              <div className="col-sm-4">
                <h6 className="taglineTxt"></h6>
                <label>Named Entity</label>
                <select className="input-group mb-3 form-control select2 "
                  id="namedEntityInDropDown" className="namedEntityInDropDown"
                  value={this.state.value}
                  onChange={this.namedEntityhandleChange}
                  style={{
                    width: '50%', height: '30px', borderRadius: '4px',
                    backgroundColor: '#F9F9FB', marginLeft: '10px'
                  }}>

                </select>
              </div>
            </div>



            <div className="row">




              {/* gender */}
              <div className="col-sm-4">
                <h6 className="taglineTxt"></h6>
                <label style={{ marginLeft: '20px' }}>Gender</label>
                <select className="input-group mb-3 form-control select2 "
                  value={this.state.value}
                  id="gender" className="gender" value={this.state.value}
                  onChange={this.genderhandleChange}
                  placeholder="Select gender"
                  style={{
                    width: '50%', height: '30px', borderRadius: '4px',
                    backgroundColor: '#F9F9FB', marginLeft: '31px'
                  }}>
                  <option hidden value='Select Gender'>Select Gender</option>
                </select>
              </div>


              {/* sub-type */}
              <div className="col-sm-4" style={{ display: this.state.hideSubType ? 'none' : 'block' }}>
                <h6 className="taglineTxt"></h6>
                <label>Sub-Type</label>
                <select className="input-group mb-3 form-control select2 "
                  id="subType" className="subType" value={this.state.value}
                  onChange={this.subTypehandleChange} placeholder="Select sub-type"
                  style={{
                    height: '30px', borderRadius: '4px',
                    backgroundColor: '#F9F9FB', width: '50%', marginLeft: '10px'
                  }}>
                  <option hidden value='Select Sub-Type'>Select Sub-Type</option>
                </select>
              </div>

              {/* custom-type */}
              <div className="col-sm-4" style={{ display: this.state.hideSubType ? 'block' : 'none' }}>
                <h6 className="taglineTxt"></h6>
                <label>Custom Entity Type</label>
                <select className="input-group mb-3 form-control select2 "
                  id="customEntityType" className="customEntityType" value={this.state.value}
                  onChange={this.customTypehandleChange} placeholder="Select custom entity type"
                  style={{
                    height: '30px', borderRadius: '4px',
                    backgroundColor: '#F9F9FB', width: '50%', marginLeft: '10px'
                  }}>

                  <option hidden value='null'>None</option>
                </select>
              </div>

              {/* review status */}
              <div className="col-sm-4" >

              </div>
            </div>
            <div className="row" id="mlcd" style={{ marginLeft: '10px' }}  >
              <div className="col-sm-4">
                <h6 className="nav-item" style={{ color: '#282a65', marginTop: '20px', marginLeft: '1px' }}>Multi Lingual Entities</h6>
              </div>
              <div className="col-sm-8" Align='right'>
                <div className="input-group search-btn" style={{
                  marginTop: '-28px', width: '200px', display: 'inline-block',
                  backgroundColor: 'rgb(249, 249, 251)'
                }} >

                  <div className="search-icon" >

                    <input className="border-none" type="search" placeholder="Search"
                      onKeyPress={this.onKeyPressHandleChange}
                      aria-label="Search"
                      style={{
                        width: '77%', height: '80%',
                        filterable: true, backgroundColor: 'rgb(249, 249, 251)',
                        font: 'bold', color: 'black'
                      }} id="query" />
                    <button onClick={this.queryHandleChange} style={{
                      border: 'none',
                      backgroundColor: '#F9F9FB'
                    }}>
                      <img src="assets/images/search.svg"
                        style={{ width: '18px', cursor: 'pointer' }} /></button>
                  </div>
                </div>
                {/* Add button and refresh button*/}

                <CheckBoxComponent label="To Be Reviewed" onChange={this.handleChecked}
                  style={{ marginTop: '14px', marginRight: '2px' }} id="toBeReviewed" checked={this.state.toBeReviewed} />
                <button className="btn action-button "
                  disabled={this.state.disableMultipleDelete}
                  title="Delete Selected"
                  id="deleteMultiple"
                  style={{ marginLeft: '35px' }}
                  onClick={() => {
                    this.setState({
                      hideMultipleDeletePopup: true
                    })
                  }
                  }>
                  <img src={"./assets/images/baseline_delete_white_24dp.png"} />
                </button>
                     <button className="btn action-button" style={{marginTop:'0px'}}
                                                                id="addMsg" title=" Delete All "
                                              onClick={() => {
                                                this.setState({
                                                  hideDeleteAllPopup: true
                                                })
                                              }}>
                                                                Delete All
                                              </button>
                <button className="btn action-button "
                  id="addMsg"
                  onClick={this.state.showBorder ? ((this.state.disabled) ? this.NotifyEmptyFields : this.addRow) : this.NotifyLanguageDataMissing}
                  title="Add">
                  <img src="assets/images/add_white_24dp.png" />
                </button>
                <button onClick={this.refreshData} className="btn action-button">
                  <img src="./assets/images/refresh_white_24dp.png" title="Refresh"></img>
                </button>
              </div>

            </div>
          </div>


          <div id="reactTable" style={{ marginLeft: '15px' }} >
            {this.contentEditiable}
            <ReactTable id='reactTable'
              onPageChange={this.onPageChange}
              page={this.state.pageNum}
              getTrProps={(state, rowInfo) => {
                if (rowInfo) {
                  return {
                    style: {
                      background: this.state.selectedRows.some((selectedRow) => selectedRow.id == rowInfo.original.id) ? '#E6E6D8' : 'white'
                    }
                  }
                } else {
                  return {}
                }
              }
              }
              data={data}
              columns={[
                {
                  Header: <b>Select</b>,
                  accessor: "id",
                  width: 55,
                  Cell: props => (
                    <div style={{ textAlign: 'center' }}>
                      <input type="checkbox"
                        disabled={props.original.id === undefined ? true : false}
                        style={{ width: "20px", height: "20px", cursor: "pointer" }}
                        onClick={(e) => {
                          this.selectedRow(props, e)
                        }}
                        checked={props.original.selected}
                      />
                    </div>)
                },
                {
                  Header: <b>English Text</b>,
                  accessor: 'englishText',
                  filterable: false,
                  Cell: props => (

                    <div
                      Align="left" className="input"
                      style={{
                        padding: '8px', width: '98%', borderBottom: 'none',
                        border: ((props.original.id == undefined || props.original.id == this.state.editedId) && this.state.checkForEmpty) ? '1px solid #D2D4DC' : 'none', borderRadius:
                          ((props.original.id == undefined || props.original.id == this.state.editedId) && this.state.checkForEmpty) ? '2px' : 'none', paddingLeft: '2px'
                      }}
                      suppressContentEditableWarning
                      contentEditable={!((props.original.id == undefined) ? false :
                        props.original.id != this.state.editedId) ? "plaintext-only" : false}

                      type="text" id={"englishText" + props.index} value={props.original.id == undefined ? "" :
                        props.original.englishText}
                    >{props.original.englishText}</div>)
                },

                {
                  Header: <b>Indic Text</b>,
                  accessor: 'indicText',
                  filterable: false,

                  Cell: props => (
                    <div
                      Align="left" className="input"
                      style={{
                        padding: '8px', width: '98%', borderBottom: 'none',
                        border: ((props.original.id == undefined || props.original.id == this.state.editedId) && this.state.checkForEmpty) ?
                          '1px solid #D2D4DC' : 'none', borderRadius:
                          (props.original.id == undefined || props.original.id == this.state.editedId) && this.state.checkForEmpty ? '2px' : 'none', paddingLeft: '2px'
                      }}
                      suppressContentEditableWarning
                      contentEditable={!((props.original.id == undefined) ? false :
                        props.original.id != this.state.editedId) ? "plaintext-only" : false}

                      type="text" id={"indicText" + props.index} value={props.original.id == undefined ? "" :
                        props.original.indicText}
                    >{props.original.indicText}</div>
                  )
                },

                {
                  Header: <b>Review</b>,
                  accessor: 'reviewed',
                  width: 100,
                  filterable: false,
                  Cell: props => {
                    return (
                      <div style={{ textAlign: 'center', display: this.state.checkForEmpty ? 'block' : 'none' }}>
                        <label class="switch">
                          <input type="checkbox" id={"reviewed" + props.index}
                            onClick={this.handleChangeReview}
                            defaultChecked={props.original.reviewed}
                            disabled={props.original.id && props.original.id != this.state.editedId}



                          />
                          <span class="slider round" ></span>
                        </label>
                      </div>)
                  }

                },

                {
                  Header: <b>Action</b>,
                  filterable: false,
                  width: 100,
                  Cell: props => {
                    return (
                      <div className="container-fluid" style={{ textAlign: "center", display: this.state.checkForEmpty ? 'block' : 'none', marginTop: '-9px' }}>
                        <img className="img-responsive" title={(props.original.id == undefined) ||
                          (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}

                          style={{ cursor: "pointer", marginTop: '8px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                          src={
                            (props.original.id == undefined)
                              ?
                              this.saveImageSrc :

                              ((props.original.id
                                != this.state.editedId)
                                ?
                                this.editImageSrc : this.saveImageSrc)}
                          onClick={(e) => {
                            (this.state.data[props.index].id == undefined)
                              ?
                              this.saveAjax(props, e)
                              :
                              ((this.state.data[props.index].id == this.state.editedId)
                                ?
                                this.updateAjax(props, e)
                                :
                                this.editCell(props, e));

                          }}
                        />
                        <img src="assets/images/baseline_delete_white_24dp.png" title="Delete"
                          style={{ marginTop: '-47px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px', cursor: 'pointer', marginLeft: '19px' }}
                          onClick={() => {
                            (props.original.id) === undefined ?
                              this.fetchMlcd() :
                              this.setState({
                                hideDeletePopup: true,
                                propsId: props.original.id
                              })

                          }} />

                      </div>
                    )
                  }
                }
              ]}


              defaultPageSize={10}
              pageSizeOptions={[5, 10, 15]}

              style={{ backgroundColor: 'white' }}
            />
            <ToastContainer className="Toast-at-center" />
            {/*Dialog Component For Deletion Confirmation*/}
            <DialogComponent width='400px' animationSettings={this.settings}
              header='Multi Lingual Entities' showCloseIcon={true} buttons={this.buttons}
              ref={dialog => this.dialogInstance = dialog}
              visible={this.state.hideDeletePopup} close={this.dialogClose}>
              <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                content="" />&nbsp;Do you want to delete MLCD?<br />Note: Press 'Yes' to delete or press 'No' to decline.
            </DialogComponent>

            {/*Dialog Component For Multiple Deletion Confirmation*/}
            <DialogComponent width='400px' animationSettings={this.settings}
              header='Multi Lingual Entities' showCloseIcon={true} buttons={this.multipleDeleteButton}
              ref={dialog => this.dialogInstance = dialog}
              visible={this.state.hideMultipleDeletePopup} close={this.dialogClose}>
              <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                content="" />&nbsp;Do you want to delete the selected multi lingual entities?<br />Note: Press 'Yes' to delete or press 'No' to decline.
            </DialogComponent>

 {/*Dialog Component For  Deletion all Confirmation*/}
            <DialogComponent width='400px' animationSettings={this.settings}
              header='Delete All' showCloseIcon={true} buttons={this.deleteAllButton}
              ref={dialog => this.dialogInstance = dialog}
              visible={this.state.hideDeleteAllPopup} close={this.dialogClose}>
              <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                content="" />&nbsp;Do you want to delete all the APIs?<br />Note: Press 'Yes' to delete or press 'No' to decline.
            </DialogComponent>






          </div>
        </div>
      </div>


    )
  }
}

export default NLPMlcd;


// WEBPACK FOOTER //
// ./src/nlpUi/NLPMlcd.js